<template>
  <div data-private class="w-full h-full"  >
    <AgGridVue
      :key="tableKey"
      :theme="standardListTheme"
      style="width: 100%; height:200px"
      :column-defs="computedColumnDefs"
      :row-data="data"
      :default-col-def="defaultColDef"
      :group-display-type="groupDisplayType"
      :grid-options="gridOptions"
      :loading="loading"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<script>
import axios from 'axios'
import { AgGridVue } from 'ag-grid-vue3'
import {standardListTheme} from '@/utils/common';


export default {
  components: {
    AgGridVue
  },
  props: {
    taskPriorActions:{
      type:Object,
      required:true
    }
  },
  data() {
    return {
      data:null,
      show_data:false,
      loading:true,
      gridApi:null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout: this.autoHeight ? 'autoHeight':null
      },
      groupDisplayType: 'singleColumn',
      defaultColDef: {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight:true,
        wrapText:true,
      },
      tableKey:0
    }
  },
  computed: {
    standardListTheme() {
      return standardListTheme
    },
    sql_filters(){
      let filters = {
        bene_mbi_id:this.beneMbiId,
      }
      if (this.clmThruDt){
        filters['clm_thru_dt'] = this.clmThruDt
      }
      if (this.tin){
        filters['tin'] = this.tin
      }
      return filters
    },
    computedColumnDefs() {
      return [
        {
          headerName: 'Action Type',
          headerTooltip: 'The prior action type',
          cellClass:'cell-theme-left-aligned font-semibold',
          field: 'action_type_name',
        },
        {
          headerName: 'User',
          headerTooltip: 'The user who submitted the prior action',
          cellClass:'cell-theme-left-aligned',
          field: 'appuser_name',
        },
        {
          headerName: 'Created At',
          headerTooltip: 'The date the action was submitted',
          cellClass:'cell-theme-left-aligned',
          field: 'created_at',
        },
      ]
    }
  },
  methods: {
    async onGridReady(params) {
      this.gridApi = params.api
      if(this.taskPriorActions){

        this.data=this.taskPriorActions
        this.loading = false
      }

      params.api.sizeColumnsToFit();
      window.addEventListener('resize', this.onWindowResize);
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
  },
  async mounted() {
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }
}

</script>

<style>

</style>
